<template>
  <div class="tab-profile">
    <div class="tab-profile-body">
      <Loading v-if="isLoadingCurrentUser" :forceLightMode="true" />

      <ProfileUser v-if="isShowProfile" />
      <AttendedPresentationDetail v-if="isShowAttendedPresentationDetail" />
      <AttendedPresentation v-if="isShowAttendedPresentationList" />
    </div>
    <ProfileFooter v-if="isShowFooter" />
  </div>
</template>
<script>
import { mapState } from 'vuex'

import AttendedPresentation from '@/components/attended-presentations/AttendedPresentation.vue'
import Loading from '@/components/Loading'
import ProfileFooter from '@/components/profile/ProfileFooter.vue'
import ProfileUser from '@/components/profile/ProfileUser.vue'

export default {
  components: {
    AttendedPresentation,
    AttendedPresentationDetail: () => import('@/components/attended-presentations/AttendedPresentationDetail.vue'),
    Loading,
    ProfileFooter,
    ProfileUser,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
      isLoadingCurrentUser: (state) => state.isLoadingCurrentUser,
      isCreatedNewAttended: (state) => state.isCreatedNewAttended,
    }),
    userLogged() {
      return this.currentUser && this.currentUser.id
    },
    shouldLoadAttendedPresentations() {
      if (this.$route.params.id) {
        return this.presentation && this.presentation.id && this.isCreatedNewAttended
      }

      return true
    },
    isShowAttendedPresentationDetail() {
      return !this.isLoadingCurrentUser && this.userLogged && this.$route.query['attended-presentation-detail']
    },
    isShowAttendedPresentationList() {
      return this.userLogged && this.shouldLoadAttendedPresentations && !this.isShowAttendedPresentationDetail
    },
    isShowProfile() {
      return !this.isLoadingCurrentUser && !this.isShowAttendedPresentationDetail
    },
    isShowFooter() {
      return !this.isLoadingCurrentUser && !this.isShowAttendedPresentationDetail
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
$tabs-height: 46px;
$progress-bar-height: 4px;

.tab-profile {
  display: grid;
  grid-template-rows: 1fr auto;
  min-height: calc(100vh - $tabs-height - $progress-bar-height);
}
</style>
